import React from 'react'
import { ExecuteOperationOnPipe, ModelWithForm } from '@morningtrain/react-resources'
import * as Fields from 'support/fields'
import { Fieldset } from 'layouts/index'
import Smartview from 'widgets/smartviews/Smartview'
import { Translation, Translator } from '@morningtrain/react-translations'
import { TriggerPipelineOnClick } from '@morningtrain/react-helpers'
import * as moment from 'moment'
import { Repeater } from '@morningtrain/react-fields-repeater-field'
import * as Icons from 'ui/icons'
import ResourceSelector from 'support/fields/simpletons/ResourceSelector'
import DeleteModelPipeline from 'support/pipelines/DeleteModelPipeline'
import DeleteButton from 'ui/buttons/DeleteButton'
import { SubmitButton } from 'ui/buttons'
import { ButtonWrap } from 'ui/layouts'
import * as UI from 'ui'
import * as Displays from 'support/displays'
import { MountSmartviewOnPipe, ResetSmartviewOnPipe } from '@morningtrain/react-smartviews'

function CreateSpecialDaySmartview (props) {
  const {
    date = null,
    id = null
  } = props

  const momentDate = date ? moment(date) : null

  const footer = (
    <>
      <ButtonWrap>
        <DeleteModelPipeline>
          <TriggerPipelineOnClick>
            <DeleteButton big />
          </TriggerPipelineOnClick>
          <ExecuteOperationOnPipe resourceName='shifts.special_days' operationName='month' />
          <ResetSmartviewOnPipe />
        </DeleteModelPipeline>

        <SubmitButton>
          <Translation name='generic.save' />
        </SubmitButton>
      </ButtonWrap>
    </>
  )

  return (
    <Translator namespace='special_days'>
      <ModelWithForm resourceName='shifts.special_days' id={id} preventParentOperationRefresh={!id}>
        <MountSmartviewOnPipe
          smartview={payload => <CreateSpecialDaySmartview id={payload.response.model.id} />}
          replace={false}
        />
        <ExecuteOperationOnPipe resourceName='shifts.special_days' operationName='month' />

        <Smartview header={<Displays.Date name='starts_at' dateFormat='D. MMM Y' defaultValue={date} />} footer={footer} size='lg'>
          <Fieldset cols={1}>
            <Fields.Input name='name' />
            <Fieldset cols={2}>
              <Fields.Date name='starts_at' defaultValue={date ? momentDate.format('YYYY-MM-DD') : null} />
              <Fields.Date name='ends_at' defaultValue={date ? momentDate.format('YYYY-MM-DD') : null} />
            </Fieldset>
            <ResourceSelector
              name='department_ids'
              optionsKey='name'
              multiple
              resourceName='departments'
            />
            <Fields.Select enum='special_day_type' name='type' />
            <Fields.TextArea name='description' />
            <Fields.File name='file' label='File'>
              <Displays.Link name='file_url'>
                <UI.Text truncate block className='w-full'>
                  <Displays.Text name='file_name' />
                </UI.Text>
              </Displays.Link>
            </Fields.File>
          </Fieldset>
          <Repeater
            name='norm_deviations' draggable={false}
            label={<Translation name='norm_deviations' />}
            buttonClass='btn btn-sq btn-primary'
            addLabel={<Icons.Plus className='w-3 h-3' />}
            removeLabel={<Icons.Trash className='w-4 h-4' />}
          >
            <Fields.Number name='inventory_norm_offset' />
            <ResourceSelector
              name='categories'
              optionsKey='name'
              resourceName='inventory.category'
            />
            <ResourceSelector
              name='products'
              optionsKey='name'
              resourceName='inventory.item'
            />
          </Repeater>
        </Smartview>
      </ModelWithForm>
    </Translator>
  )
}

export default CreateSpecialDaySmartview
